// extracted by mini-css-extract-plugin
module.exports = {"Inner":"Content__Inner_E9Pln","Title":"Content__Title_2bqQ0","SubTitle":"Content__SubTitle_BNYLi","List":"Content__List_7NR_q grid"};